import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export function Input({ label, error, helperText, className = '', ...props }: InputProps) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-[#1f2933] dark:text-[#e5e5e5] mb-1.5 font-mono">
          {label}
          {props.required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}
      <input
        className={`
          w-full px-3 py-2 bg-white dark:bg-[#1a1a1a] dark:text-[#e5e5e5] border rounded-none
          focus:outline-none focus:ring-1 focus:ring-gray-500 focus:border-gray-500
          disabled:bg-gray-100 dark:disabled:bg-[#222222] disabled:text-gray-500
          placeholder:text-gray-300 dark:placeholder:text-gray-600 font-mono text-sm
          [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none
          ${error ? 'border-red-500' : 'border-gray-300 dark:border-[#333333]'}
          ${className}
        `}
        {...props}
      />
      {helperText && !error && (
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 font-mono">{helperText}</p>
      )}
      {error && <p className="mt-1 text-xs text-red-600 font-mono">{error}</p>}
    </div>
  );
}
